import React, { Component } from "react";
import classnames from "classnames";

import { ButtonProps } from "../common/Button";
import { IconButton } from "../common/IconButton";
import * as styles from "./AddButton.scss";

export interface IAddButtonProps extends ButtonProps {
    to?: string;
}

export class AddButton extends Component<IAddButtonProps> {
    public render() {
        const { to, ...props } = this.props;

        return (
            <IconButton
                {...props}
                className={classnames(styles["add-button"], styles.button)}
                icon="plus"
                to={to}
            />
        );
    }
}
